import React from 'react';
import './AboutUs.css';

function AboutUs() {
  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="hero-background">
          <div className="hero-overlay">
            <div className="hero-content">
              <h1 className="hero-title">About SANAFIR GOLD</h1>
              <p className="hero-subtitle">Crafting Excellence Since Generations</p>
            </div>
          </div>
        </div>
      </section>

      {/* Story Section */}
      <section className="story-section">
        <div className="container">
          <div className="story-content">
            <h2>Our Story</h2>
            <p>
              SANAFIR GOLD has been a trusted name in the jewelry industry for generations. 
              We specialize in creating exquisite gold and diamond jewelry that celebrates life's 
              most precious moments. Our commitment to quality, craftsmanship, and customer 
              satisfaction has made us a preferred choice for jewelry lovers across the UAE.
            </p>
            <p>
              Located in the heart of Sharjah, our showroom showcases a stunning collection of 
              traditional and contemporary jewelry pieces. Each piece is carefully crafted by 
              skilled artisans who bring decades of experience and passion to their work.
            </p>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="values-section">
        <div className="container">
          <h2 className="section-title">Our Values</h2>
          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon">💎</div>
              <h3>Quality</h3>
              <p>We use only the finest materials and maintain the highest standards in every piece we create.</p>
            </div>
            <div className="value-card">
              <div className="value-icon">🎨</div>
              <h3>Craftsmanship</h3>
              <p>Our skilled artisans bring decades of experience and attention to detail to every design.</p>
            </div>
            <div className="value-card">
              <div className="value-icon">❤️</div>
              <h3>Trust</h3>
              <p>We build lasting relationships with our customers through transparency and reliability.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default AboutUs;
